import { render, staticRenderFns } from "./MultiPurposeSettings.vue?vue&type=template&id=204041fb&"
import script from "./MultiPurposeSettings.vue?vue&type=script&lang=js&"
export * from "./MultiPurposeSettings.vue?vue&type=script&lang=js&"
import style0 from "./MultiPurposeSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports